import { useParams } from 'react-router-dom'
import ModalCreateEdit from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import useLangData from '../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs } from '../../../../../../utils/reducers/getters'
import { ModifiedCreateProductModelType } from '../../../../types'


interface CreateLotProductProps extends ModalEditComponentProps {}

const CreateLotProduct: React.FC<CreateLotProductProps> = ({ allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: allRowData?.basicData.ProductLangs, fieldsToLang: ['name'], keyValue: 'LangId' })
    const params = useParams<{ id: string }>()
    const ProductId = params.id
    const fields: FormRender<ModifiedCreateProductModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang,
                    required: true
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name']?.[selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'nameLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
                {
                    name: 'unique_number',
                    label: t('lotNumber', 'Número de lote'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'uniqueProduct',
                    label: '',
                    component: 'InputHidden',
                    type: 'hidden',
                    value: 'true',
                },
                {
                    name: 'ProductId',
                    label: '',
                    component: 'InputHidden',
                    type: 'hidden',
                    value: ProductId,
                },
            ]
        }
    ]
    return (<ModalCreateEdit fields={fields} url={'/api/app/product/createProduct'} translations={{
        title: t('createLotProduct', 'Crear Lote'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default CreateLotProduct